
<template>
	<compWrapper title="基本信息" theme="primary">
		<compFormQuery
			col="1"
			class="margin-layout width-60per"
			ref="formbase"
			:formdata="getBase"
			v-model="formData"
			:labelWidth="120"
		/>
		<div class="text-right padding-right-10">
			<vButton @click="close">返回</vButton>
		</div>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</compWrapper>
</template>

<script>
import mixin from './detailmixin';
export default {
	mixins: [mixin],
	data() {
		return {
			id: this.$route.query.id,
		}
	},
	methods: {
		close() {
			this.$router.push({
				name: 'noticeList'
			})
		}
	},

}
</script>


